import React, { useState } from 'react';
import axios from 'axios';
import { XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { getAuthHeaders } from '../contexts/AuthContext';

export const CancelDraftButton = ({ planId, onCancelled, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const cancel = async () => {
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/shipment-planning/allocation-plans/${planId}/cancel`, {}, { headers: getAuthHeaders() });
      toast.success('Draft cancelled. Stock and PO demand released.');
      setOpen(false);
      await onCancelled();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not cancel draft');
    } finally {
      setBusy(false);
    }
  };
  return <>
    <Button variant="outline" size="sm" disabled={disabled || busy} onClick={() => setOpen(true)} data-testid={`cancel-draft-${planId}`}>
      <XCircle className="mr-1.5 h-4 w-4" /> Cancel draft
    </Button>
    <Dialog open={open} onOpenChange={(value) => { if (!busy) setOpen(value); }}>
      <DialogContent className="max-w-md" data-testid={`cancel-draft-dialog-${planId}`}>
        <DialogHeader>
          <DialogTitle data-testid={`cancel-draft-title-${planId}`}>Cancel this draft?</DialogTitle>
          <DialogDescription data-testid={`cancel-draft-description-${planId}`}>Reserved stock and PO quantities will be released. No shipments or receipt quantities will change.</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" disabled={busy} onClick={() => setOpen(false)} data-testid={`keep-draft-${planId}`}>Keep draft</Button>
          <Button variant="destructive" disabled={busy} onClick={cancel} data-testid={`confirm-cancel-draft-${planId}`}>{busy ? 'Cancelling…' : 'Cancel draft'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
};